import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import { db, firebase } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import { Redirect } from "react-router-dom";
import { useLocation } from "react-router";
import {Button} from "@material-ui/core";

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      format="+7 ### ### ####"
    />
  );
});

NumberFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

async function addInvited(uid) {
  const userRef = db.doc(`users/${uid}`);

  userRef.get().then((doc) => {
    if (doc.exists) {
      const user = doc.data();

      let invited = user.invited + 1;
      let points = user.points + 10;
      if (invited <= 10) {
        userRef.set(
          {
            invited,
            points,
          },
          { merge: true }
        );
      }
    }
  });
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Login() {
  const [values, setValues] = React.useState({
    phonenumber: "",
  });
  let q = useQuery();
  const [otp, setOtp] = useState("");
  const [show, setShow] = useState(false);
  const [final, setFinal] = useState("");
  const [uid, setUid] = useState(null);
  const [inviteUid, setInviteUid] = useState(null);
  const [redirectToDashboard, setRedirectToDashboard] = useState(false);
  const [redirectToRegister, setRedirectToRegister] = useState(false);

  useEffect(() => {
    if (q.get("id") !== null) {
      setInviteUid(q.get("id"));
    } else {
      setInviteUid("");
    }
  }, [inviteUid, q]);

  const { login } = useAuth();

  const signIn = (e) => {
    e.preventDefault();
    if (values.phonenumber === "" || values.phonenumber.length < 9) return;

    let verify = new firebase.auth.RecaptchaVerifier("recaptcha-container");
    login("+7" + values.phonenumber, verify)
      .then((result) => {
        setFinal(result);
        setShow(true);
      })
      .catch((err) => {
        alert(err);
        window.location.reload();
      });
  };

  const ValidateOtp = () => {
    if (otp == null || final == null) return;
    final
      .confirm(otp)
      .then((result) => {

        setTimeout(function () {
          setUid(result.user.uid);
          if (result.additionalUserInfo.isNewUser) {
            if (inviteUid !== "") {
              addInvited(inviteUid).then(() => {
                setRedirectToRegister(true);
              });
            } else {
              setRedirectToRegister(true);
            }
          } else {
            setRedirectToDashboard(true);
          }
        },500);


      })
      .catch((err) => {
        alert("Wrong code");
      });
  };

  const handleClose = () => setShow(false);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <>
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            src="https://firebasestorage.googleapis.com/v0/b/gto-container.appspot.com/o/mossport.png?alt=media&token=422f53a0-6391-4882-9751-c186f923017c"
            sx={{ m: 1, bgcolor: "red", height: 70, width: 70 }}
          ></Avatar>
          <Typography component="h1" variant="h5">
            Вход
          </Typography>
          {show ? null : (
            <Box component="form" noValidate sx={{ mt: 1 }}>
              <TextField
                label="Номер телефона"
                value={values.phonenumber}
                name="phonenumber"
                id="phonenumber-input"
                fullWidth
                onChange={handleChange}
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />

              <Box
                sx={{ marginTop: 2 }}
                component="div"
                id="recaptcha-container"
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="error"
                sx={{ mt: 3, mb: 2 }}
                onClick={signIn}
              >
                Войти
              </Button>
            </Box>
          )}

          {show ? (
            <Box
              sx={{
                mt: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Введите код из смс
              </Typography>

              <TextField
                onChange={(e) => {
                  setOtp(e.target.value);
                }}
                sx={{ marginTop: 2 }}
                id="outlined-basic"
                label="Код"
                variant="outlined"
              />

              <Button
                type="submit"
                variant="contained"
                color="error"

                onClick={ValidateOtp}
              >
                Подтвердить
              </Button>
            </Box>
          ) : null}
        </Box>

        {redirectToDashboard ? <Redirect to="/" /> : null}
        {redirectToRegister ? <Redirect to={"/register?id=" + uid} /> : null}
      </Container>

      {/*<Modal
        open={show}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Введите смс код
            </Typography>

            <TextField
              onChange={(e) => {
                setOtp(e.target.value);
              }}
              sx={{ marginTop: 2 }}
              id="outlined-basic"
              label="Код"
              variant="outlined"
            />

            <Button
              type="submit"
              variant="contained"
              color="error"
              sx={{ mt: 3 }}
              onClick={ValidateOtp}
            >
              Подтвердить
            </Button>
          </Box>
        </Box>
      </Modal>*/}
    </>
  );
}

export default Login;
